export let devicePixelRatio = 1;
export let transform = 'transform';
export let csstransform = 'transform';
export let scrollbarSize = 0;
export let scriptUrl = '';
export let baseUrl = '';
export let isMobile = false;
export let isIE = false;
export let isEdge = false;
export let isIOS = false;
export let isSafari = false;
export let isFirefox = false;
export let isOpera = false;
export let isChrome = false;
export let isHeadless = false;
export let isBot = false;
export let hasObjectFitSupport = false;
export let hasObjectPositionSupport = false;
export let hasPositionStickySupport = false;
export let hasWebPSupport = false;
export let hasAVIFSupport = false;
export let hasWOFF2Support = false;
export let NEEDS_MANUAL_SNAPPING = false;
export let orientation = 'landscape';
export let contentScale = 1;
export let wheelEvent = 'wheel';
export let has3d = true;
export let hasLocalStorage = false;
export let locale = 'en';


export const Cookies = {
	get(_name) {
		if (!IS_BROWSER) { return ''; }
		const trim = s => s.trim();
		const cookies = (document.cookie || '').split(';').map(trim)
			.map(s => s.split('=').map(trim));
		for (let i = 0; i < cookies.length; i++) {
			const name = cookies[i][0];
			const value = cookies[i][1];
			if (name === _name) {
				return value;
			}
		}
		return null;
	},
	set(name, value, expires='Fri, 31 Dec 9999 23:59:59 GMT', domain = '') {
		document.cookie = `${name}=${value}; path=/;${expires ? ` expires=${expires}` : '' } ;${domain ? ` domain=${domain};`: ''}`;
	}
};

export function log(msg, context) {
	if (IS_BROWSER && window.Sentry) {
		context.tags = context.tags || {logger: 'kent-next'};
		context.level = context.level || 'info';
		context.fingerprint = ['{{ default }}'].concat(context.fingerprint) || ['{{ default }}'];

		window.Sentry.withScope(scope => {
			scope.setTags(context.tags);
			scope.setLevel(context.level);
			scope.setFingerprint(context.fingerprint);
			scope.setExtras(context.extra);

			window.Sentry.captureMessage(msg);
		});
	}
}

function handleResize() {
	orientation = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';

	contentScale = orientation === 'landscape'
		? Math.round(devicePixelRatio * window.innerHeight / 768)
		: Math.round(devicePixelRatio * window.innerWidth / 512);
}

if (IS_BROWSER) {
	// simply disable this altogether on ios since both safari and the UIWebView
	// are horribly broken
	NEEDS_MANUAL_SNAPPING =
		navigator.standalone || // UIWebView
		navigator.platform.substr(0, 2) === 'iP' || // iphone / ipod devices
		/Chrome/.test(navigator.userAgent); // chrome

	const el = document.createElement('p');

	// basics
	devicePixelRatio = window.devicePixelRatio || 1;
	wheelEvent = 'onwheel' in el ? 'wheel' : 'mousewheel';
	hasObjectFitSupport = (typeof CSS !== 'undefined' && CSS.supports) ? CSS.supports('object-fit', 'cover') : false;
	hasObjectPositionSupport = (typeof CSS !== 'undefined' && CSS.supports) ? CSS.supports('object-position', '100px 50px') : false;
	hasPositionStickySupport = (typeof CSS !== 'undefined' && CSS.supports) ? CSS.supports("(position: sticky) or (position: -webkit-sticky)") : false;

	if(window.psHasWebPSupport) {
		hasWebPSupport = true;
	}
	// quick check for recent chrome, since google pagespeed insights uses it
	if (!hasWebPSupport) {
		const m = window.navigator.userAgent.match(/Chrome\/([0-9]+)/);
		hasWebPSupport = m && m.length > 1 && parseInt(m[1]) >= 83;
	}
	//if still no webp support
	//webp - based on https://stackoverflow.com/a/27232658 + https://stackoverflow.com/a/54120785
	if(!hasWebPSupport) {
		const webPCanvas = document.createElement('canvas');
		if (!!(webPCanvas.getContext && webPCanvas.getContext('2d'))) {		
			//this will only work properly in chrome
			hasWebPSupport = webPCanvas.toDataURL('image/webp').indexOf('data:image/webp') == 0;
		}
	}
	if(!hasWebPSupport) {
		const webP = new Image();
		webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
		webP.onload = webP.onerror = () => {
			hasWebPSupport = (webP.height === 2);
		};
	}

	if (window.psHasAVIFSupport) {
		hasAVIFSupport = true;
	}

	if (!hasAVIFSupport) {
		const m = navigator.userAgent.indexOf("Edg/") < 0 && window.navigator.userAgent.match(/Chrome\/([0-9]+)/);
		hasAVIFSupport = m && m.length > 1 && parseInt(m[1]) >= 89;

		if (!hasAVIFSupport) {
			const avif = new Image();
			avif.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=";
			avif.onload = avif.onerror = () => {
				hasAVIFSupport = (avif.height === 2);
			}
		}
	}

	if (window.psHasWOFF2Support) {
		hasWOFF2Support = true;
	}

	if (!hasWOFF2Support) {
		const m = navigator.userAgent.indexOf("Edg/") < 0 && window.navigator.userAgent.match(/Chrome\/([0-9]+)/);
		  
		hasWOFF2Support = m && m.length > 1 && parseInt(m[1], 10) >= 36;
		  
		if (!hasWOFF2Support && typeof window !== "undefined" && ("FontFace" in window)) {
			const testFont = new FontFace(
				"t",
				'url( "data:font/woff2;base64,d09GMgABAAAAAADwAAoAAAAAAiQAAACoAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAABmAALAogOAE2AiQDBgsGAAQgBSAHIBuDAciO1EZ3I/mL5/+5/rfPnTt9/9Qa8H4cUUZxaRbh36LiKJoVh61XGzw6ufkpoeZBW4KphwFYIJGHB4LAY4hby++gW+6N1EN94I49v86yCpUdYgqeZrOWN34CMQg2tAmthdli0eePIwAKNIIRS4AGZFzdX9lbBUAQlm//f262/61o8PlYO/D1/X4FrWFFgdCQD9DpGJSxmFyjOAGUU4P0qigcNb82GAAA" ) format( "woff2" )',
				{}
			  );
	
			  testFont.display = "swap";
			  testFont.load().catch(() => 0);
	
			  hasWOFF2Support = ["loading", "loaded"].includes(testFont.status);
		}
	}

	handleResize();
	window.addEventListener('orientationchange', handleResize, false);
	window.addEventListener('resize', handleResize, false);

	// the transform property
	const transforms = {
		transform: 'transform',
		webkitTransform: '-webkit-transform',
		MozTransform: '-moz-transform',
		msTransform: '-ms-transform',
		OTransform: '-o-transform',
	};

	const props = Object.keys(transforms);
	for (let i = 0; i < props.length; i++) {
		if (el.style[props[i]] !== null && el.style[props[i]] !== undefined) {
			transform = props[i];
			break;
		}
	}

	csstransform = transforms[transform];

	// whether we have 3d transforms or not
	el.style[transform] = 'translate3d(1px,1px,1px)';
	el.style['flex-wrap'] = 'wrap';
	document.body.appendChild(el);
	const gcs = getComputedStyle(el);
	const trans = gcs.getPropertyValue(csstransform);
	document.body.removeChild(el);

	has3d = trans !== null && trans.length && trans !== 'none';

	// scrollbar size
	el.style.width = '50px';
	el.style.height = '50px';
	el.style.overflow = 'scroll';
	el.style.position = 'absolute';
	el.style.top = '-9999px';

	document.body.appendChild(el);
	scrollbarSize = el.offsetWidth - el.clientWidth;
	document.body.removeChild(el);

	// script baseUrl etc
	if (document.currentScript) {
		scriptUrl = document.currentScript.src;
	} else {
		// Well, IE/Edge do not support currentScript, so we have to find the
		// script ourselves, which is a bit tricky. Also, we use this code in both
		// the loader and the main player, which makes it even more complicated.
		// So we iterate over all the scripts, looking for one that includes our
		// player filename (kind of).
		// But the file name will not match in case we run this from the loader
		// script, in which case this will just iterate to the end and take the
		// script url of the last script on the page, which in the case of the
		// loader is the loader itself because the script is executed
		// synchronously.
		const scripts = document.querySelectorAll('script[src]');
		for (let i = 0; i < scripts.length; i++) {
			scriptUrl = scripts[i].src;
			if (scriptUrl.indexOf("/kent.") !== -1) {
				break;
			}
		}
	}
	scriptUrl = scriptUrl.replace(/\/[^/]*$/, '/');

	const loc = document.location;
	baseUrl = `${loc.protocol}//${loc.host}/`;

	isIE = navigator.userAgent.indexOf('MSIE') > 0 || navigator.userAgent.indexOf('Trident/') > 0;
	isEdge = navigator.userAgent.indexOf('Edge/') > 0;
	isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  	isSafari = !isChrome && /Version\/[\d\.]+.*Safari/.test(navigator.userAgent);
  	isIOS = /iP(ad|od|hone)/i.test(navigator.userAgent) || (isSafari && "ontouchend" in document);
	isOpera = navigator.userAgent.indexOf('OPR/') > 0;
	isFirefox = navigator.userAgent.indexOf('Firefox/') > 0;
	isHeadless = navigator.userAgent.indexOf('Headless') > 0;
	isBot = /bot|spider|Qwantify|naver\.me|Lighthouse/i.test(navigator.userAgent);

	// http://stackoverflow.com/questions/3514784/what-is-the-best-way-to-detect-a-mobile-device-in-jquery/3540295#3540295
	if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) ||
		/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) { isMobile = true; }

	const lsTest = 'test';
	try {
		localStorage.setItem(lsTest, lsTest);
		localStorage.removeItem(lsTest);
		hasLocalStorage = true;
	} catch(e) {}

	locale = (navigator.languages && navigator.languages.length
		? navigator.languages[0]
		: (navigator.language || navigator.userLanguage)).split('-')[0].toLowerCase();
}



// WEBPACK FOOTER //
// ./lib/environment.js